<div class="center">
  <!-- Buscador y Filtro de fechas -->
  <div class="search-and-filter">
    <nz-input-group nzPrefixIcon="search">
      <input
        type="text"
        nz-input
        placeholder="Buscar..."
        [(ngModel)]="searchTerm"
      />
    </nz-input-group>
    <nz-input-group>
      <input
        type="date"
        nz-input
        placeholder="Fecha de inicio"
        [(ngModel)]="startDate"
      />
    </nz-input-group>
    <nz-input-group>
      <input
        type="date"
        nz-input
        placeholder="Fecha de fin"
        [(ngModel)]="endDate"
      />
    </nz-input-group>
  </div>

  <nz-table
    [nzData]="paginatedData"
    [nzBordered]="true"
    [nzSize]="'default'"
    [nzShowPagination]="false"
    [nzScroll]="{ x: 'auto' }">


    <thead>
    <tr>
      <th nzWidth="40px">#</th>
      <th>Campo</th>
      <th>DNI/RUC</th>
      <th>Fecha Reserva</th>
      <th>Horario Reserva</th>
      <th>Código de Pago</th>
      <th>Estado</th>
      <th>Total</th>
      <th>Descuento</th>
      <th>N° Recibo</th>
      <th>Acciones</th>
    </tr>
    </thead>

    <tbody>
    <tr *ngFor="let reserva of paginatedData; let i = index">
      <td>{{ getRowNumber(i) }}</td>
      <td>{{ reserva.campo }}</td>
      <td>{{ getDniORuc(reserva.persona) }}</td>
      <td>{{ reserva.fechaReserva }}</td>
      <td>{{ reserva.horarioInicio }} - {{ reserva.horarioFin }} </td>
      <td>{{ reserva.codigoPago }}</td>
      <td>
        <app-tag
          [text]="reserva.estado"
          [color]="reserva.estado === 'Pagado' ? 'red' : 'green'">
        </app-tag>
      </td>
      <td>{{reserva.total}}</td>
      <td>{{reserva.descuento}}% - {{reserva.motivo_descuento}}</td>
      <td>{{ reserva.num_recibo }}</td>
      <td class="table-cell">
        <button class="action-button" nz-button nzType="default" (click)="onCheck(reserva)">
          <nz-icon nzType="check"></nz-icon>
        </button>
        <button class="action-button" nz-button *ngIf="showEditButton" nzType="default" (click)="onEdit(reserva)">
          <nz-icon nzType="edit"></nz-icon>
        </button>
        <button class="action-button" nz-button *ngIf="showDeleteButton" nzType="default" (click)="onDelete(reserva)">
          <nz-icon nzType="delete"></nz-icon>
        </button>
        <button class="action-button" nz-button nzType="default" (click)="onDownloadPDF(reserva.id)">
          <nz-icon nzType="download"></nz-icon>
        </button>
      </td>
    </tr>
    </tbody>
  </nz-table>

  <nz-pagination
    [nzPageIndex]="pageIndex"
    [nzTotal]="length"
    [nzPageSize]="pageSize"
    (nzPageIndexChange)="onPageChange($event)">
  </nz-pagination>

</div>
